import { Injectable } from '@angular/core';
import { DvDynamicFormElement } from '@devinco/ui/legacy';
import { DvPeriodPickerControlValue } from '@devinco/ui/legacy';
import { FilterModelWithKeys } from '@features/vt-grid/interfaces/grid-context';
import { TripFilterDto, Driver } from '@pages/reports-page/interfaces';
import { PeriodInterval } from '@shared/components/edit-trip-filter-dialog/constants';
import { DataFilterCreateEditForm } from '@shared/components/edit-trip-filter-dialog/interfaces';
import { DepartmentDto } from '@shared/interfaces/department';
import DynamicFormUtils from '@shared/utils/dynamic-form.utils';

@Injectable({ providedIn: 'root' })
export class ExtraFilterDataSaveService {
  prepareDataForSave(
    formData: DataFilterCreateEditForm,
    multiselectElements: DvDynamicFormElement[],
    filterModel: FilterModelWithKeys,
    weekDays?: number[],
    isTripsFiltersPage = false
  ): TripFilterDto {
    const payload = {
      Name: formData.Name,
      Description: formData.Description,
      Interval: formData.Interval,
      IntervalTo: this.formatTimeInput(formData.IntervalTo),
      IntervalFrom: this.formatTimeInput(formData.IntervalFrom),
      DistanceGreater: formData.DistanceGreater,
      DistanceLess: formData.DistanceLess,
      Department: formData.Department
        ? DynamicFormUtils.getSelectedDataFromMultiselectDropdown<DepartmentDto>(
            multiselectElements.find(el => el.options.key === 'Department')!,
            formData.Department,
            'DepartmentID'
          ).map(department => ({
            DepartmentID: department.DepartmentID,
          }))
        : undefined,
      Driver: formData.Driver
        ? DynamicFormUtils.getSelectedDataFromMultiselectDropdown<Driver>(
            multiselectElements.find(el => el.options.key === 'Driver')!,
            formData.Driver,
            'UserID'
          ).map(user => ({
            UserID: user.UserID,
          }))
        : undefined,
      WeekDay: weekDays,
      FilterModel: filterModel,
      StartDay: formData.StartDay,
      EndDay: formData.EndDay,
      VisibleToAllUsers: formData.VisibleToAllUsers,
    } as TripFilterDto;

    if (formData.Period) {
      payload.Period = isTripsFiltersPage
        ? ((
            formData.Period as DvPeriodPickerControlValue
          ).selectedFilter?.filterKey?.split('.')[1] as
            | PeriodInterval
            | undefined) || PeriodInterval.Custom
        : (formData.Period as unknown as PeriodInterval);
    }

    if (!formData.Department) {
      delete payload.Department;
    }

    if (!formData.Driver) {
      delete payload.Driver;
    }

    if (!payload.WeekDay) {
      delete payload.WeekDay;
    }

    return payload;
  }

  private formatTimeInput(time: string | undefined): string | undefined {
    if (!time) return undefined;
    return time
      .replace(/^(\d{2}):$/, '$1:00') // If "00:", add "00" after ":"
      .replace(/^:(\d{2})$/, '00:$1');
  }
}
